// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SmallAccountMenuButton-cls1___c0d517c7394acebee02{/*!*/}.SmallAccountMenuButton-cls2___5c883c1e3df6dfef1b7{width:40px;width:var(--spacing-md-40, 40px);height:40px;height:var(--spacing-md-40, 40px);border-radius:50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SmallAccountMenuButton-cls1___c0d517c7394acebee02",
	"cls2": "SmallAccountMenuButton-cls2___5c883c1e3df6dfef1b7 SmallAccountMenuButton-cls1___c0d517c7394acebee02"
};
export default ___CSS_LOADER_EXPORT___;
